import Vue from 'vue'
import Console from '../vuetify-console'

// Start for decoupling reusable components for console
Vue.use(Console)
